import { useProductData as sharedUseProductData } from '@shared/products-core';

export const useProductData: typeof sharedUseProductData = (...args) =>
    sharedUseProductData(...args);
